<template>
  <quote-wrapper
    :quote="quote"
    :details="qd"
    @toggle-quote-shown="$emit('toggle-quote-shown', $event)"
  >
    <!-- DESKTOP -->
    <template #desktop-quote>
      <quote-desktop
        :quote="quote"
        :details="qd"
        :is-view-monthly="isViewMonthly"
        :optional-extra="qd.optionalExtra"
        @click-policy-details="onClickViewDetails(quote)"
        @open-more-info="onClickViewDetails(quote)"
      />
    </template>

    <!-- TABLETS/MOBILES -->
    <template #mobile-quote>
      <quote-mobile
        :quote="quote"
        :details="qd"
        :is-view-monthly="isViewMonthly"
        :optional-extra="qd.optionalExtra"
        :cover-type-related-label="coverTypeRelatedLabel"
        :covered-extra-labels="getCoveredExtrasLabels"
        @click-policy-details="onClickViewDetails(quote)"
        @open-more-info="onClickViewDetails(quote)"
      />
    </template>

    <template
      v-if="$vuetify.breakpoint.smAndDown"
      #caption
    >
      <v-divider class="mt-3" />

      <p
        class="mb-2 fs-14"
      >
        <v-btn
          text
          color="primary"
          class="pa-0"
          @click="$emit('open-drawer-details', ['details-description', 'coverTypes'])"
        >
          {{ qd.coverType }}
        </v-btn> policy.
      </p>
    </template>
  </quote-wrapper>
</template>

<script>
import QuoteWrapper from '@/components/results/QuoteWrapper';
import QuoteDesktop from './QuoteDesktop';
import QuoteMobile from './QuoteMobile';

export default {
  name: 'results-quote',
  components: {
    QuoteWrapper,
    QuoteDesktop,
    QuoteMobile,
  },
  props: {
    quote: {
      type: Object,
      required: true,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    coverTypeRelatedLabel: {
      type: String,
      default: '',
    },
    detailsDescription: {
      type: Object,
      required: true,
    },
  },
  computed: {
    qd () {
      return this.quote.details[0];
    },
    optionalExtra () {
      return this.qd.optionalExtra;
    },
    coveredOptionalExtras () {
      const covered = [];

      Object.keys(this.qd.optionalExtra).forEach(item => {
        if (this.qd.optionalExtra[item].included === 'Y') {
          covered.push(item);
        }
      });

      return covered;
    },
    getCoveredExtrasLabels () {
      const names = [];
      this.coveredOptionalExtras.forEach(item => {
        this.detailsDescription.content.forEach(detail => {
          if (detail.slug === item) {
            names.push(detail.name);
          };
        });
      });

      return names;
    },
  },
  methods: {
    onClickViewDetails (quote) {
      this.$emit('click-view-details', quote);
      this.$emit('open-drawer-details', ['results-details', 'optionalExtras']);
    },
  },
};
</script>
